import { defineComponent as _defineComponent } from 'vue'
import TripItineraryV2 from "@/components/TripItineraryV2.vue";
import SalesBotMap from '@/components/SalesBotMap.vue'
import SalesBotTripSummaryVehicles from '@/components/SalesBotTripSummaryVehicles.vue'
import SalesBotTripSummaryDetails from '@/components/SalesBotTripSummaryDetails.vue'
import SalesBotToBookingButton from '@/components/SalesBotToBookingButton.vue'

import { useSalesBotStore } from "@/store/modules/salesBot";
import { computed } from "vue";
import { useDisplay } from '@/composables/useDisplay'
import { LatLng } from '@/models/LatLng'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripSummary',
  props: {
    closeable: { type: Boolean, default: false },
    isModalOpen: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { closeable: boolean, isModalOpen: boolean };

const salesBotStore = useSalesBotStore()
const display = useDisplay()





const areAllStepsValid = computed<boolean>(() => {
  const accordionSteps = salesBotStore?.accordionSteps ?? []
  return accordionSteps.every(({isValid}) => isValid)
})

const tripSummary = computed(() => {
  return salesBotStore.tripSummary
})

const waypoints = computed<LatLng[]>(() => {
  const waypoints: LatLng[] = []

  salesBotStore.stops.forEach((stop) => {
    const address = stop.address
    if (address?.lat && address?.lng) {
      waypoints.push({ lat: address.lat, lng: address.lng })
    }
  })
  return waypoints
})

const smAndDown = computed(() => display.smAndDown.value)
const smOnly = computed(() => display.smOnly.value)
const xsOnly = computed(() => display.xs.value)

const shouldShowVehicles = computed(() => tripSummary.value.vehicles.length)
const shouldShowDetails = computed(() => tripSummary.value.passengers || tripSummary.value.specialRequirements.length || tripSummary.value.amenities.length)




return { __sfc: true,salesBotStore, display, emit, props, areAllStepsValid, tripSummary, waypoints, smAndDown, smOnly, xsOnly, shouldShowVehicles, shouldShowDetails, TripItineraryV2, SalesBotMap, SalesBotTripSummaryVehicles, SalesBotTripSummaryDetails, SalesBotToBookingButton }
}

})